const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebb"
    },
    d: "M20.7,20c-0.1,0.3-0.3,0.7-0.4,0.9c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0-0.4-0.2-0.4-0.4   c0-0.2,0-0.4,0.1-0.6c0-0.5,0.1-1,0.1-1.5c0-5.7-3.4-6.7-8.6-6.7H8.4V15c0,0.4-0.3,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.5-0.2L1,9.4   C0.8,9.2,0.8,9,0.8,8.8c0-0.2,0.1-0.4,0.2-0.5l6.1-6.1C7.3,2,7.5,1.9,7.7,1.9c0.4,0,0.8,0.3,0.8,0.8v3.1h2.7   c3.9,0,8.8,0.7,10.5,4.8c0.5,1.3,0.6,2.6,0.6,4C22.2,16.2,21.4,18.4,20.7,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.0eaf5cc447cbd1058eaeca4380028223.svg";
export { ForwardRef as ReactComponent };